import { render, staticRenderFns } from "./DesempenoSup.vue?vue&type=template&id=0de1b425&scoped=true&"
import script from "./DesempenoSup.vue?vue&type=script&lang=js&"
export * from "./DesempenoSup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1b425",
  null
  
)

export default component.exports